import {onMounted} from 'vue'

import {useStore} from 'vuex'
import {useRoute} from 'vue-router'

const LIGHTHOUSE_TIMEOUT = 1000

const preloadAsset = ({type, path}, store) => {
  if (type === 'AUDIO') {
    return store.dispatch('getAudio', path)
  }

  if (type === 'VIDEO') {
    return store.dispatch('commitVideo', path)
  }

  // TODO: IMAGE type
}

const preload = function (assets, store) {
  if (assets) {
    assets.forEach((asset) => {
      preloadAsset(asset, store)
    })
  }
}

const handleAsset = (asset, resolve) => {
  if (asset.readyState === 4) {
    resolve(asset)
  } else {
    asset.addEventListener('canplaythrough', () => {
      resolve(asset)
    })
  }
}

export const getAssetFromStore = ({type, path}, store) => {
  return new Promise((resolve) => {
    if (store.state.preloadedAssets[path]) {
      const asset = store.state.preloadedAssets[path]
      handleAsset(asset, resolve)
      console.log('asset already preloaded')
      console.log(asset)
    } else {
      console.log('asset not preloaded')
      preloadAsset({type, path}, store).then(() => {
        const asset = store.state.preloadedAssets[path]
        handleAsset(asset, resolve)
        console.log('asset preloaded and ready')
        console.log(asset)
      })
    }
  })
}

let domContentLoaded = false

export function usePreloader() {
  const route = useRoute()
  const store = useStore()

  const doPreload = () => {
    setTimeout(() => {
      preload(route.meta.preloadAssets, store)
    }, LIGHTHOUSE_TIMEOUT)
  }

  onMounted(() => {
    console.log(domContentLoaded)
    preload(route.meta.preloadAssets, store)
    /*
    if (domContentLoaded) {
      preload(route.meta.preloadAssets, store)
    } else {
      window.addEventListener('DOMContentLoaded', () => {
        domContentLoaded = true

        doPreload()
      })
    }
    */
  })

  const getAsset = (asset) => {
    return getAssetFromStore(asset, store)
  }

  return {getAsset}
}
